module.exports = __webpack_public_path__ + "static/assets/8dce2d7771264c77592cb6fc0c778101.png";